import 'react-app-polyfill/ie11.js';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    postVerificationSizeUpdates,
    setOptions,
    setViewModel,
    getAllEmptyViewModels,
    EmploymentPersonalInfoViewModel as ViewModel,
    overrideComponent,
} from '@sheerid/jslib';

import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { ACCEPTABLE_ORGS } from './constants';
import { getQueryParamsByName } from './lib/utils/browser';
import { StepEmploymentPersonalInfoComponent } from './components/StepEmploymentPersonalInfoComponent';

const qspOrgIdNumber = Number.parseInt(getQueryParamsByName('orgId'), 10) || 0;

const company = ACCEPTABLE_ORGS.find((org) => org.id === qspOrgIdNumber);

if (company) {
    const viewModel: ViewModel = getAllEmptyViewModels().collectEmployeePersonalInfo as ViewModel;
    viewModel.organization = company;
    setViewModel(viewModel);
}

// @ts-ignore
overrideComponent('StepEmploymentPersonalInfoComponent', StepEmploymentPersonalInfoComponent);

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
